import XWLoginForm from "./common/XWLoginForm/XWLoginForm.vue";
import XWViewFooter from "./common/XWViewFooter/ViewFooter.vue";
import XWViewHeader from "./common/XWViewHeader/ViewHeader.vue";
import FormList from "./common/FormList/FormList.vue";

export default {
  install(Vue) {
    Vue.component("XWLoginForm", XWLoginForm);
    Vue.component("XWViewFooter", XWViewFooter);
    Vue.component("XWViewHeader", XWViewHeader);
    Vue.component("FormList", FormList);
  }
};



// WEBPACK FOOTER //
// ./src/components/index.js